export default __webpack_public_path__ + "static/media/sticker-B.f5e0001b.png";